import React from 'react'
import {FaLinkedinIn, FaGithub, FaInstagram, FaYoutube} from 'react-icons/fa'

const openInNewTab = url => {
    window.open(url, '_blank', 'noopener,noreferrer');
}
const Main = () => {
  return (
    
    <div id = 'home' className = "w-full h-screen text-center">
      <div className = "max-w-[1240px] w-full h-full mx-auto flex justify-center items-center">
          <div>
                <p className = "uppercase text-sm tracking-widest text-gray-600">Let's Start Coding</p>
                <h1 className = "py-4 text-gray-700">
                    Hi, I'm <span className = "text-[#5651e5]">Ankur</span> 
                </h1>
                <h1 className = "py-2 text-gray-700">
                    A Competitive Programmer
                </h1>
                <p className = "py-4 text-gray-600 max-w-[70%] m-auto ">
                        I am a Competitve Programmer and a Front-End Web Developer
                        Technology Enthusiast and a Keen Learner.
                </p>
                <div className = "flex items-center justify-between max-w-[330px] m-auto py-4 ">
                    <div className = "rounded-full shadow-lg shadow-gray-400 p-6 cursor-pointer hover:scale-110 ease-in duration-300" onClick={() => openInNewTab('https://www.linkedin.com/in/ankur-gupta-a93832201/')}>
                        <FaLinkedinIn />
                    </div>
                    <div className = "rounded-full shadow-lg shadow-gray-400 p-6 cursor-pointer             hover:scale-110 ease-in duration-300" onClick={() => openInNewTab('https://github.com/Modernbeast02')}>
                        <FaGithub />
                    </div>
                    <div className = "rounded-full shadow-lg shadow-gray-400 p-6 cursor-pointer     hover:scale-110 ease-in duration-300" onClick={() => openInNewTab('https://www.instagram.com/ankurgupta_0205/')}>
                        <FaInstagram />
                    </div>
                    <div className = "rounded-full shadow-lg shadow-gray-400 p-6 cursor-pointer hover:scale-110 ease-in duration-300" onClick={() => openInNewTab('https://www.youtube.com/channel/UCHDKLvHgL-Anxe1LNekleVw')}>
                        <FaYoutube />
                    </div>
                </div>
          </div>
      </div>
    </div>
  )
}

export default Main
